/** Insumo o materia prima del menú (se compra y se consume al preparar platos). */
export class Insumo {
  id: string;
  name: string;
  unit: string; // ej: "kg", "unidad", "L"
  quantity: number;
  minStock?: number;
  active: boolean = true;
  createdAt: Date;
  updatedAt: Date;

  constructor(id: string, name: string, unit: string, quantity: number = 0) {
    this.id = id;
    this.name = name;
    this.unit = unit;
    this.quantity = quantity;
    this.active = true;
    this.createdAt = new Date();
    this.updatedAt = new Date();
  }
}

/** Línea de receta: cuánto insumo consume un plato por unidad. */
export interface RecipeLine {
  insumoId: string;
  quantityPerUnit: number;
}

/** Receta de un plato del menú (qué insumos y cuánto por unidad). */
export interface Recipe {
  menuItemId: string;
  items: RecipeLine[];
}
